module.exports = __webpack_public_path__ + "img/kai.d453f3c0.png";